const CurrentOrder = require('../current-order');
const css = require('./order-wrapper.css');
const { cut } = require('../../../../helpers/utils');
const signals = require('../../../../signals/account/orders');
let BitrixExportLeads = require('../current-order/bitrix-export-leads');
let { redirect } = require('../../../../signals/utils');
const ordersComputedActions = require('../../../../actions/computed/account/orders');
const currentOrderActions = require('../../../../actions/account/current-order');

class OrderWrapper {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(signals.wrapperOnLoad);

        return {
            click: {
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }
}

module.exports = {
    constructor: OrderWrapper,
    children: [
        {
            name: 'current-order',
            component: CurrentOrder,
            watcher: {
                exportResult: ['account', 'orders', 'currentOrder', 'exportResult'],
                necessaryDocuments: ['account', 'orders', 'currentOrder', 'necessaryDocuments'],
                specialInfo: ['account', 'orders', 'computed', 'componentsState', 'specialInfo'],
                showActionPanel: ['account', 'orders', 'computed', 'componentsState', 'showActionPanel'],
                showSumCanChangeTooltip: ordersComputedActions.PATHS.isShowSumCanChangeTooltip,
                showPriceMustBeBiggerThanZero: currentOrderActions.PATHS.showPriceMustBeBiggerThanZero,
                showChangesMustBeSavedOrCancelled: ['account', 'orders', 'currentOrder', 'tooltips',
                    'showChangesMustBeSavedOrCancelled'],
                showDataChangeTooltip: ['account', 'orders', 'computed', 'componentsState', 'showDataChangeTooltip'],
                showDataOutdatedTooltip: ['account', 'orders', 'currentOrder', 'isDataOutdated'],
                showExportResult: ['account', 'orders', 'computed', 'componentsState', 'showExportResult'],
                isManager: ['user', 'isManager'],
                freeLeadsAmount: ['account', 'orders', 'currentOrder', 'freeLeadsAmount'],
                isShowOrderParameters: ordersComputedActions.PATHS.isShowOrderParameters,
                isShowIndividualOrderParameters: ordersComputedActions.PATHS.isShowIndividualOrderParameters,
                isShowResultUploadButton: ordersComputedActions.PATHS.isShowResultUploadButton,
                isLoadingUploadResultDocument: ordersComputedActions.PATHS.isLoadingUploadResultDocument,
                isShowUploadResultFailTooltip: currentOrderActions.PATHS.isShowUploadResultFailTooltip
            }
        },
        {
            name: 'leads',
            component: BitrixExportLeads,
            watcher: {
                hermesFields: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hermesFields'],
                hasFieldCreationRight: ['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                    'hasFieldCreationRight'],
                freeLeadsAmount: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'freeLeadsAmount'],
                isOnlyFreeLeads: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isOnlyFreeLeads']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/order-wrapper/index.js